import { Dialog } from '@headlessui/react'
import { ModalStore } from '../../state/ModalStore'
import { XIcon } from '@heroicons/react/outline'

function ModalHeader({ title, onCancel, onClose }) {
    const skimModal = ModalStore((state) => state.skim)

    const handleCancel = async () => {
        if (onClose) {
            await onClose()
        } else {
            if (onCancel) await onCancel()
            skimModal()
        }
    }

    return (
        <Dialog.Title className="flex items-center justify-between bg-[linear-gradient(90deg,#ED5C2F,#F28230)] px-5 py-[15px] text-white">
            <div className="min-w-0 flex-1 text-left text-[15px] font-bold">
                {title}
            </div>
            <button
                onClick={handleCancel}
                type="button"
                className="ml-4 inline-flex h-[30px] w-[30px] items-center justify-center rounded-lg bg-white/20 text-white transition hover:bg-white/30 focus:outline-none focus:ring-2 focus:ring-white/40">
                <XIcon className="h-4 w-4" />
            </button>
        </Dialog.Title>
    )
}

export default ModalHeader
